import { CreateTagRequest } from '@app/models/requests';
import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export const createTag = async (data: CreateTagRequest) => {
  return apiInstance.post(
    `${ApiRoutes.Business}${ApiRoutes.Tags}/create`,
    data
  );
};

export const getTag = async () => {
  return apiInstance.get(`${ApiRoutes.Business}${ApiRoutes.Tags}/`);
};

export const getPaginatedTags = async (params: {
  page: number;
  perPage: number;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}) => {
  return apiInstance.get(`${ApiRoutes.Business}${ApiRoutes.Tags}/paginated`, { params });
};

export const getTagById = async (id: string) => {
  return apiInstance.get(`${ApiRoutes.Business}${ApiRoutes.Tags}/${id}`);
};

export const getTagCustomers = async (id: string, params: { page: number; limit: number }) => {
  return apiInstance.get(`${ApiRoutes.Business}${ApiRoutes.Tags}/customers/${id}`, { params });
};

export const updateTag = async (id: string, data: { name: string }) => {
  return apiInstance.put(`${ApiRoutes.Business}${ApiRoutes.Tags}/${id}`, data);
};

export const getTagsDeleteImpact = async (ids: number[]) => {
  return apiInstance.post(`${ApiRoutes.Business}${ApiRoutes.Tags}/delete-impact`, { ids });
};

export const deleteManyTags = async (ids: number[], pauseAutomations: boolean) => {
  return apiInstance.post(`${ApiRoutes.Business}${ApiRoutes.Tags}/delete-many`, { ids, pauseAutomations });
};
